import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import classnames from 'classnames';

const Tag = createClass({
  propTypes: {
    label: PropTypes.string,
    icon: PropTypes.string,
    className: PropTypes.string,
    onClose: PropTypes.func,
    active: PropTypes.bool,
    disabled: PropTypes.bool
  },

  render() {
    const {label, onClose, active, icon, className, disabled, ...other} = this.props;
    const containerClassName = classnames('vf-tag', className, {
      disabled,
      active,
      'vf-clickable': !disabled,
      '-with-close': onClose
    });

    return (
      <div className={containerClassName} {...other}>
        {icon && (
          <span className={`margin-right-Hx vf-h2 icon icon-${icon}`} />
        )}
        <span className='vf-tag-label vf-font-bold'>
          {label}
        </span>

        {onClose && (
          <div
            className='flex center-xs vf-clickable vf-close-tag'
            onClick={onClose}
          >
            <i
              className='vf-icon icon-close'
              style={{marginTop: '0.5rem', marginLeft: '2.1rem'}}
            />
          </div>
        )}
      </div>
    );
  }
});

module.exports = Tag;
